import { useEffect } from 'react';
import type { ThemePreference } from '@markbird/shared';
import { useStore } from '../store/useStore';

/**
 * Applies the theme preference to `document.documentElement[data-theme]` and
 * keeps it in sync with the OS when preference is `system`. The pre-paint inline
 * script in index.html handles the very first render; this keeps it live.
 */
export function useTheme(): void {
  const theme = useStore((s) => s.theme);

  useEffect(() => {
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const apply = (pref: ThemePreference) => {
      const dark = pref === 'dark' || (pref === 'system' && mql.matches);
      document.documentElement.dataset.theme = dark ? 'dark' : 'light';
    };
    apply(theme);
    if (theme === 'system') {
      const onChange = () => apply('system');
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    return undefined;
  }, [theme]);
}
